const IMAGE_IDENTITY_BASE_URL = "https://image-identity.local";
const URL_SCHEME_PATTERN = /^[a-zA-Z][a-zA-Z\d+.-]*:/;

export function getImageIdentity(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  if (url.startsWith("blob:") || url.startsWith("data:")) {
    return url;
  }

  try {
    const parsedUrl = new URL(url, IMAGE_IDENTITY_BASE_URL);
    const hasExplicitOrigin = URL_SCHEME_PATTERN.test(url) || url.startsWith("//");

    return hasExplicitOrigin ? `${parsedUrl.origin}${parsedUrl.pathname}` : parsedUrl.pathname;
  } catch {
    return url;
  }
}

/**
 * Module-level cache mapping image identity (origin+pathname) to the first
 * full URL observed for that identity. When the backend returns the same image
 * with a rotated signed query string, this keeps the original URL so the
 * browser can serve from its HTTP cache instead of re-fetching.
 */
const stableUrlCache = new Map<string, string>();

export function getStableImageUrl(url: string): string;
export function getStableImageUrl(url: string | null): string | null;
export function getStableImageUrl(url: string | undefined): string | undefined;
export function getStableImageUrl(url: string | null | undefined): string | null | undefined;
export function getStableImageUrl(url: string | null | undefined): string | null | undefined {
  if (!url) return url;

  const identity = getImageIdentity(url);
  if (!identity || identity === url) return url;

  const cached = stableUrlCache.get(identity);
  if (cached) return cached;

  stableUrlCache.set(identity, url);
  return url;
}

export function clearStableImageUrlCache(): void {
  stableUrlCache.clear();
}
